import { render, staticRenderFns } from "./delete-modal.html?vue&type=template&id=66ea2b5d&scoped=true&"
import script from "./delete-modal.js?vue&type=script&lang=js&"
export * from "./delete-modal.js?vue&type=script&lang=js&"
import style0 from "./delete-modal.scss?vue&type=style&index=0&id=66ea2b5d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea2b5d",
  null
  
)

export default component.exports